module.exports = __webpack_public_path__ + "img/manage-news.2a580a51.svg";